'use strict';

var MarketIndicatorsDataProviderService = function MarketIndicatorsDataProviderService(dataRetrieverService, constantsService) {
  function getRetriever() {
    return dataRetrieverService.getDataRetriever(constantsService.ROM_ANALYSIS_SCREEN, constantsService.ROM_ANALYSIS_SKINNY_SERVICES_MODE);
  }
  function getData(componentId) {
    if (componentId) {
      return getRetriever().retrieveComponentData(componentId);
    }
  }
  function getFilters() {
    return getRetriever().brushFilters();
  }

  //calling .localSortApplied() on init prevents hanging application when this method would be called many times in very short time
  getRetriever().localSortApplied();
  return {
    getData: getData,
    getFilters: getFilters
  };
};
MarketIndicatorsDataProviderService.$inject = ['DataRetrieverService', 'DataRetrieverConstantsService'];
module.exports = MarketIndicatorsDataProviderService;